import { instance as axios } from "./baseUrl";

export const claimEmail = (data) => axios.post("/email", data);

export const postClaim = (data) => axios.post("/claims", data);

export const getClaims = () => axios.get("/claims");

// Derrière le JWT : plus d'URL publique /uploads (STU-84).
export const getClaimDocumentFile = (id) => axios.get(`/claims/documents/${id}`, {responseType: "blob"});
